import {
	registerDecorator,
	ValidationArguments,
	ValidationOptions,
	ValidatorConstraint,
	ValidatorConstraintInterface,
} from 'class-validator';

type FragranceOfferValue = {
	storeId?: number;
	buyUrl?: string;
};

@ValidatorConstraint({ name: 'uniqueFragranceOffers', async: false })
export class UniqueFragranceOffersConstraint implements ValidatorConstraintInterface {
	private static getDuplicateOffer(offers: unknown) {
		if (!Array.isArray(offers)) return null;

		const seen = new Set<string>();
		for (const item of offers as FragranceOfferValue[]) {
			if (!item || item.storeId === undefined || item.buyUrl === undefined) continue;

			const key = `${item.storeId}:${item.buyUrl}`;
			if (seen.has(key)) return item;
			seen.add(key);
		}

		return null;
	}

	validate(offers: unknown, _args: ValidationArguments) {
		return !UniqueFragranceOffersConstraint.getDuplicateOffer(offers);
	}

	defaultMessage(args: ValidationArguments) {
		const duplicate = UniqueFragranceOffersConstraint.getDuplicateOffer(args.value);
		if (!duplicate) return 'Offers must be unique by store and buy URL';

		return `Duplicate offer for storeId ${duplicate.storeId} and buyUrl ${duplicate.buyUrl}`;
	}
}

export function UniqueFragranceOffers(validationOptions?: ValidationOptions) {
	return function (object: Object, propertyName: string | symbol) {
		registerDecorator({
			target: object.constructor,
			propertyName: propertyName.toString(),
			options: validationOptions,
			constraints: [],
			validator: UniqueFragranceOffersConstraint,
		});
	};
}
